export default __webpack_public_path__ + "static/media/vcooking.642a960e.gif";